import ourJquery from 'jquery';

// Use existing global jquery if present already,
// otherwise make "our" bundled jquery globally available
// for legacy code/external code by e.g. sitepark (sitekit components, verzeichnisdienst pflegeheime, citygov etc.)
const jquery = window.jQuery || ourJquery;

window.$ = jquery;
window.jQuery = jquery;

export default jquery;
